import React, {useState, useEffect} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAllSubjects } from '../../redux/action/studentAction'
import HomeHelper from '../../Components/HomeHelper'
import { useHistory } from 'react-router-dom'
import '../../Style/StuResult.css';
import Footer from '../../Components/Footer';
import Loading from '../../Components/Loading';

const StudentSubjectList = () => {
    const store = useSelector((store) => store)
    const history = useHistory()
    const dispatch = useDispatch()
    useEffect(() => {
       dispatch(getAllSubjects())
    },[])
    const isSubjectAvailable = store.student.allSubjects && store.student.allSubjects.length > 0;

    return (
        <>
            {store.student.isAuthenticated ? <>
                <HomeHelper />
                <div className="container-fluid main"style={{ backgroundImage: 'url("/image/pattern.png")', backgroundRepeat: 'repeat' }}>
                <div className='px-4 py-1 bg-light d-flex align-items-center justify-content-between'>
                            <h3 className='d-flex align-items-center justify-content-between'> <img src="/logo192.png" width={'40px'} alt="" /> Result</h3>
                            <button onClick={()=> window.print()} type="button" className=" btn-success btn text-light"> <img src="/image/print.svg" lt="" /> Download</button>
                        </div>
                    <div className="row mt-3">
                        <div className="col-md-10 m-auto">
                        <div className='resultT p-2'>
                            <h2 className='text-center'>Subjects & Notes</h2><br />
                           <div className='d-flex align-items-center justify-content-around '> <h5>Department :{store.student.student.student.department} </h5>
                            <h5>Year :{store.student.student.student.year} </h5>
                            <h5>Semester:{store.student.student.student.semester} </h5>
                            <h5>Section:{store.student.student.student.section} </h5></div>
                        </div>
                            <table className="table p-2 resultT table-responsive table-striped table-bordered">
                                <thead>
                                    <tr className="table resultTcol text-light">
                                        <th scope="col " width="5%">S.No</th>
                                        <th scope="col" width="10%">Subject Code</th>
                                        <th scope="col" width="20%">Subject Name</th>
                                        <th scope="col" width="10%">Type</th>
                                        <th scope="col" width="10%">Model</th>
                                        <th scope="col" width="10%">Year</th>
                                        <th scope="col" width="10%">Sem</th>
                                        <th scope="col" width="10%">Credit</th>
                                        <th scope="col" width="10%">Notes</th>
                                    </tr>
                                </thead>
                                {isSubjectAvailable ? (
                                <tbody>
                                    {
                                        store.student.allSubjects.map((res, index) =>
                                            <tr key={index}>
                                                <th scope="row">{index + 1}</th>
                                                <td>{res.subjectCode}</td>
                                                <td>{res.subjectName}</td>
                                                <td>{res.subType}</td>
                                                <td>{res.subModel}</td>
                                                <td>{res.year}</td>
                                                <td>{res.semester}</td>
                                                <td>{res.subCredit}</td>
                                                <td><button className='btn btn-success'>Download</button></td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                                ) : (
                                    <Loading />
                                )}
                            </table>
                        </div>
                    </div>
                </div></> : (history.push('/'))}

                <Footer />
           
            </>
    )
}

export default StudentSubjectList
